import React from 'react';
import {
    IonButton,
    IonFooter,
    IonItem,
    IonLabel,
    IonList,
    IonText,
    IonToolbar,
} from '@ionic/react';
import { Control, FieldErrors, UseFormHandleSubmit, UseFormRegister } from 'react-hook-form';
import CurrencyPrefix from '../../../components/financials/currency-prefix';
import Input from '../../../components/input/Input';
import { CartItem } from '../../../models';
import { CheckoutFormFields, checkoutFormFieldInputs } from '../../../forms/storefront/checkout.form';
import { formatMoney } from '../../../utils/currency';

export interface StorefrontCheckoutProps {
    cart: CartItem[];
    cartTotal: number;
    currencyPrefix?: string;
    isFetching: boolean;
    errorMessage?: string;
    control: Control<CheckoutFormFields>;
    register: UseFormRegister<CheckoutFormFields>;
    errors: FieldErrors<CheckoutFormFields>;
    handleSubmit: UseFormHandleSubmit<CheckoutFormFields>;
    onSubmit: (data: CheckoutFormFields) => Promise<void>;
}

export const StorefrontCheckoutComponent: React.FC<StorefrontCheckoutProps> = ({
    cart,
    cartTotal,
    currencyPrefix,
    isFetching,
    errorMessage,
    control,
    register,
    errors,
    handleSubmit,
    onSubmit,
}) => {
    if (cart.length === 0) {
        return (
            <div className="ion-padding">
                <IonText data-testid="checkout-empty">
                    <p>Your cart is empty.</p>
                </IonText>
            </div>
        );
    }

    return (
        <>
            <div className="ion-padding">
                <IonList>
                    {cart.map((item) => (
                        <IonItem key={item.id} data-testid={`checkout-item-${item.id}`}>
                            <IonLabel>
                                <h2>{item.product.name}</h2>
                                <p>
                                    Qty: {item.quantity} &times;{' '}
                                    <CurrencyPrefix prefix={currencyPrefix} />
                                    {formatMoney(item.product.price)}
                                </p>
                            </IonLabel>
                        </IonItem>
                    ))}
                </IonList>

                <form onSubmit={handleSubmit(onSubmit)}>
                    <Input
                        {...checkoutFormFieldInputs.email}
                        control={control as unknown as Control}
                        register={register}
                        errors={errors}
                        isDisabled={isFetching}
                    />
                    <div className="ion-text-right ion-margin-top">
                        <IonButton
                            type="submit"
                            disabled={isFetching}
                            data-testid="checkout-pay-button"
                        >
                            Pay
                        </IonButton>
                    </div>
                </form>

                {errorMessage && (
                    <IonText color="danger" data-testid="checkout-error">
                        <p>{errorMessage}</p>
                    </IonText>
                )}
            </div>

            <IonFooter>
                <IonToolbar color="primary">
                    <div slot="start" style={{ paddingLeft: '16px', fontWeight: 'bold' }}>
                        Total:{' '}
                        <CurrencyPrefix prefix={currencyPrefix} />
                        <span data-testid="checkout-cart-total">{formatMoney(cartTotal)}</span>
                    </div>
                </IonToolbar>
            </IonFooter>
        </>
    );
};

export default StorefrontCheckoutComponent;
